import { useEffect, useState } from 'react';

/**
 * Hook that maintains previous data during loading states
 * @template T The type of data being retained
 * @param currentData The current data that may be loading
 * @param isLoading Boolean indicating if data is currently loading
 * @returns Object containing retained data and loading state
 */
function useRetainedState<T>(
  currentData: T | undefined | null,
  isLoading: boolean,
): {
  retainedData: T | undefined | null;
  isLoading: boolean;
} {
  const [retainedData, setRetainedData] = useState<T | undefined | null>(currentData);

  useEffect(() => {
    // Only update retained data when loading completes and we have new data
    if (!isLoading && currentData) {
      setRetainedData(currentData);
    }
  }, [isLoading, currentData]);

  return {
    retainedData,
    isLoading,
  };
}

export { useRetainedState };
